import { ReactElement } from "react";
import Layout from "../../components/layout";
import MerchantCashPay from "../../components/Shops/CashPay";

const MerchantCashPayPage = (): ReactElement => {
  return (
    <Layout>
      <MerchantCashPay />
    </Layout>
  );
};

export default MerchantCashPayPage;
